import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { Intent } from '@blueprintjs/core'

import * as actions from '../../../store/actions'
import { getObjectValues } from '../../../Utils'
import AdminTitleInfo from '../../../components/AdminTitleInfo/AdminTitleInfo'
import AdminTasksTable from '../../../components/AdminTasksTable/AdminTasksTable'

class Customers extends Component {

  updateCustomer = (customer) => {
    this.props.firebase
      .set(`tasks/customers/${customer.id}`, customer)
      .then(() => { })
      .catch((error) => {
        this.props.onToast('error', Intent.DANGER, 'Error: ' + error.message)
      })
  }

  render() {
    return (
      <div>
        <AdminTitleInfo
          title="Customers"
          info="Lists of all customers in the system. They are displayed in timesheet of all users."
        />
        <AdminTasksTable
          tasks={this.props.customers}
          updateTask={this.updateCustomer}
          taskType="customer"
        />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onToast: (iconName, intent, message) => dispatch(actions.toast({ icon: iconName, intent: intent, message: message })),
  }
}

export default compose(
  firebaseConnect([
    'tasks/customers',
  ]),
  connect((state, props) => ({
    customers: state.firebase.data.tasks ? getObjectValues(state.firebase.data.tasks.customers) : [],
  })),
  connect(mapDispatchToProps)
)(Customers)